module.exports = __webpack_public_path__ + "ed9384a0b9e7178a4ac96280345ddbcd.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/sms-credit/sms-credit-zh.html
// module id = 1972
// module chunks = 0